export const pointMarkerPolygon = (x, y, pointRadius, isMobile, orientation) => {
  if (isMobile) {
    x = Number(x)
    y = Number(y)

    const scale = orientation==='landscape' ? 1.10 : 1.10;
    const yOffset = -70;

    const halfSize = pointRadius * 6 * scale

    const xRight = x + halfSize
    const xLeft = x - halfSize
    const yTop = y - halfSize + yOffset
    const yBottom = y + halfSize + yOffset

    return [
      [xLeft, yTop],
      [xRight, yTop],
      [xRight, yBottom],
      [xLeft, yBottom],
      [xLeft, yTop]
    ];
  } else {
    x = Number(x)
    y = Number(y)
    const polygon = [[x, y]]

    const pointDrawRadius = pointRadius * 3
    const xRight = x + pointDrawRadius
    const xLeft = x - pointDrawRadius
    const pointW = pointDrawRadius * 2

    polygon.push([xLeft, y - pointW])
    polygon.push([x, y - (pointW * 2)])
    polygon.push([xRight, y - pointW])
    polygon.push([x, y])

    return polygon
  }
}
